import { defineMessages } from 'react-intl';

import { ReportGenerationErrorCode } from '@/shared/api/protocol-ts/model/dto_report_generation_error_codes_pb';
import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { Report_CBCT_IOS_Superimposition_Orientation } from '@/shared/api/protocol-ts/model/dto_report_type_cbct_ios_superimposition_pb';

// TODO: [4|m] Refactor with many object as a collection inside i18n object like in other enitites
export const i18n = defineMessages<ReportType>({
  [ReportType.ReportType_InvalidValue]: {
    id: 'ReportType.ReportType_InvalidValue',
    defaultMessage: 'ReportType_InvalidValue',
  },
  // Radiological
  [ReportType.ReportType_CBCT_GP]: {
    id: 'ReportType.ReportType_CBCT_GP',
    defaultMessage: 'CBCT AI Report',
  },
  [ReportType.ReportType_CBCT_Segmentation]: {
    id: 'ReportType.ReportType_CBCT_Segmentation',
    defaultMessage: 'STL',
  },
  [ReportType.ReportType_CBCT_OrthoSlides]: {
    id: 'ReportType.ReportType_CBCT_OrthoSlides',
    defaultMessage: 'Orthodontic Reports',
  },
  [ReportType.ReportType_CBCT_Implant]: {
    id: 'ReportType.ReportType_CBCT_Implant',
    defaultMessage: 'Implantology Study',
  },
  [ReportType.ReportType_CBCT_Endo]: {
    id: 'ReportType.ReportType_CBCT_Endo',
    defaultMessage: 'Endodontic Study',
  },
  [ReportType.ReportType_CBCT_Molar]: {
    id: 'ReportType.ReportType_CBCT_Molar',
    defaultMessage: 'Third Molar Study',
  },
  [ReportType.ReportType_Pano_GP]: {
    id: 'ReportType.ReportType_Pano_GP',
    defaultMessage: 'Pano AI Report',
  },
  // FMX
  [ReportType.ReportType_IOXRay_GP]: {
    id: 'ReportType.ReportType_IOXRay_GP',
    defaultMessage: 'IOXRay AI Report',
  },
  [ReportType.ReportType_DentalPhoto_GP]: {
    id: 'ReportType.ReportType_DentalPhoto_GP',
    defaultMessage: 'ReportType_DentalPhoto_GP',
  },
  [ReportType.ReportType_IOS_Segmentation]: {
    id: 'ReportType.ReportType_IOS_Segmentation',
    defaultMessage: 'ReportType_IOS_Segmentation',
  },
  [ReportType.ReportType_CBCT_IOS_Superimposition]: {
    id: 'ReportType.ReportType_CBCT_IOS_Superimposition',
    defaultMessage: 'ReportType_CBCT_IOS_Superimposition',
  },
  [ReportType.ReportType_StudioImplant]: {
    id: 'ReportType.ReportType_ImplantStudio',
    defaultMessage: 'Implant Report',
  },
  [ReportType.ReportType_Photo_Ortho]: {
    id: 'ReportType.ReportType_Photo_Ortho',
    defaultMessage: 'ReportType_Photo_Ortho',
  },
  [ReportType.ReportType_StudioOrtho]: {
    id: 'ReportType.ReportType_OrthoStudio',
    defaultMessage: 'Ortho Report',
  },
  [ReportType.ReportType_Pano_Bitewings]: {
    id: 'ReportType.ReportType_Pano_Bitewings',
    defaultMessage: 'Panowings AI Report',
  },
});

export const reportGeneratingErrorMessages =
  defineMessages<ReportGenerationErrorCode>({
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Unspecified]: {
      id: 'reportGenerationError.unexpectedError',
      defaultMessage:
        'Something went wrong. Try again later or contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_StudyUpload_Failed]: {
      id: 'reportGenerationError.studyUpload_errors',
      defaultMessage:
        'The upload of the study has been cancelled or has failed. Please try again later or contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_StudyUpload_Canceled]:
      {
        id: 'reportGenerationError.studyUpload_errors',
        defaultMessage:
          'The upload of the study has been cancelled or has failed. Please try again later or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_GeneratedAssetUpload_Failed]:
      {
        id: 'reportGenerationError.unexpectedError',
        defaultMessage:
          'Something went wrong. Try again later or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_FileCannotBeRead]: {
      id: 'reportGenerationError.fileError',
      defaultMessage:
        'The file or files cannot be read. Please ensure that you have uploaded appropriate files. If the problem persists contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_IsNot2DImage]: {
      id: 'reportGenerationError.dicom_isNot2DImage',
      defaultMessage:
        'The uploaded file is not a 2D image. Please upload the correct file. If the problem persists contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_IsNot3DImage]: {
      id: 'reportGenerationError.dicom_isNot3DImage',
      defaultMessage:
        'The uploaded file is not a 3D image. Please upload the correct file. If the problem persists contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_InsufficientVolume]:
      {
        id: 'reportGenerationError.dicom_insufficientVolume',
        defaultMessage: 'Dicom insufficient volume',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_DuplicateSlices]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NonDerivableVoxelSize]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NonDerivableRescaleInterceptAttribute]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NonDerivableRescaleSlopeAttribute]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NonDerivableImagePositionPatientAttribute]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_UnexpectedModality]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NonDerivableSlicePosition]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_NoPixelData]:
      {
        id: 'reportGenerationError.dicom_metadata_error',
        defaultMessage:
          'The file or files cannot be read due to DICOM metadata error. Please check that you’ve uploaded the correct file or files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_InputData_UnexpectedStudyQuantity]:
      {
        id: 'reportGenerationError.fileError',
        defaultMessage:
          'The file or files cannot be read. Please ensure that you have uploaded appropriate files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_InputData_UnexpectedStudyContent]:
      {
        id: 'reportGenerationError.fileError',
        defaultMessage:
          'The file or files cannot be read. Please ensure that you have uploaded appropriate files. If the problem persists contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_InputData_BadTaskParameters]:
      {
        id: 'reportGenerationError.inputData_badTaskParameters',
        defaultMessage: 'Input data bad task parameters',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_CbctIosMisalignment]:
      {
        id: 'reportGenerationError.modeling_cbctIosMisalignment',
        defaultMessage:
          'Input CBCT and IOS meshes do not match. Please check that CBCT and IOS studies are of decent quality and belong to the same patient, or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_IosWrongOcclusion]:
      {
        id: 'reportGenerationError.modeling_iosWrongOcclusion',
        defaultMessage:
          'Input IOS meshes are in wrong occlusion. Please select another IOS study or contact our support team for assistance.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_IosMissingJaw]:
      {
        id: 'reportGenerationError.modeling_iosMissingJaw',
        defaultMessage:
          'Input IOS meshes do not contain lower or upper jaw. Please select another IOS study or contact our support team for assistance.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_RequestedToothNotFound]:
      {
        id: 'reportGenerationError.modeling_requestedToothNotFound',
        defaultMessage:
          'The requested tooth is not found. Please select an existing tooth or contact our support team for assistance.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_ValidTimeExpired]: {
      id: 'reportGenerationError.unexpectedError',
      defaultMessage:
        'Something went wrong. Try again later or contact our support team.',
    },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_MultipleStudies]:
      {
        id: 'reportGenerationError.unexpectedError',
        defaultMessage:
          'Something went wrong. Try again later or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Dicom_Metadata_InvalidVoxelSize]:
      {
        id: 'reportGenerationError.unexpectedError',
        defaultMessage:
          'Something went wrong. Try again later or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_CbctIosImpossibleSuperimposition]:
      {
        id: 'reportGenerationError.unexpectedError',
        defaultMessage:
          'Something went wrong. Try again later or contact our support team.',
      },
    [ReportGenerationErrorCode.ReportGenerationErrorCode_Modeling_CBCT_Endo_ToothRootsNotFound]:
      {
        id: 'reportGenerationError.unexpectedError',
        defaultMessage:
          'Something went wrong. Try again later or contact our support team.',
      },
  });

export const superimpositionOrientationLabels =
  defineMessages<Report_CBCT_IOS_Superimposition_Orientation>({
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_CBCT]:
      {
        id: 'orderReportModal.orientation.cbct',
        defaultMessage: 'CBCT',
      },
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_Zero_index]:
      {
        id: 'orderReportModal.orientation.zeroIndex',
        defaultMessage: 'Zero-index',
      },
    [Report_CBCT_IOS_Superimposition_Orientation.CBCT_IOS_Superimposition_Orientation_IOS]:
      {
        id: 'orderReportModal.orientation.ios',
        defaultMessage: 'Intraoral Scan',
      },
  });
